import { useEffect, useState } from "react";
//import { useNavigate } from "react-router-dom";
import { api } from "../../api/api";
import { formatarNomeUpper, aplicarMascaraCPF } from "../../utils/formatadores";

// Função para calcular os dias transcorridos e determinar a cor da categoria
const obterStatusDias = (dataIso) => {
  if (!dataIso) return { texto: "-", cor: "#6b7280" };

  const dataAtendimento = new Date(dataIso);
  const hoje = new Date();

  dataAtendimento.setHours(0, 0, 0, 0);
  hoje.setHours(0, 0, 0, 0);

  const diferencaEmMs = hoje.getTime() - dataAtendimento.getTime();
  const dias = Math.floor(diferencaEmMs / (1000 * 60 * 60 * 24));

  // Formatação do Texto
  let texto = `${dias} dias`;
  if (dias === 0) texto = "Hoje";
  if (dias === 1) texto = "1 dia";

  // Categoria de Cores
  let cor = "#16a34a"; // Verde (<= 10 dias)

  if (dias >= 11 && dias <= 15) {
    cor = "#d97706"; // Amarelo/Laranja (11 a 15 dias)
  } else if (dias > 15) {
    cor = "#dc2626"; // Vermelho (> 15 dias)
  }

  return { texto, cor, dias };
};

const Peticionar = () => {
  //const navigate = useNavigate();
  const [atendimentos, setAtendimentos] = useState([]);
  const [confirmandoId, setConfirmandoId] = useState(null);
  const [loadingId, setLoadingId] = useState(null);

  useEffect(() => {
    const carregar = async () => {
      try {
        const response = await api.get("/processos/peticionar");

        const filtrados = response.data.filter(
          (a) => a.proximoPasso === "peticionar" || a.proximoPasso === "analisar"
        );

        setAtendimentos(filtrados);
      } catch (err) {
        console.error(err);
      }
    };

    carregar();
  }, []);

  // 🚀 Função chamada ao clicar no botão Peticionar / Confirmar
  const handlePeticionar = async (atendimento) => {
    const id = atendimento.id || atendimento._id;

    if (!id) return;

    // Primeiro clique: solicita confirmação
    if (confirmandoId !== id) {
      setConfirmandoId(id);
      return;
    }

    try {
      setLoadingId(id);

      // Atualiza o próximo passo para concluído no banco de dados
      await api.put(`/atendimento/${id}/atualizar-atendimento`, {
        proximoPasso: "concluido",
      });

      // Remove da lista exibida na tela instantaneamente
      setAtendimentos((prev) =>
        prev.filter((item) => (item.id || item._id) !== id)
      );

      setConfirmandoId(null);
    } catch (err) {
      console.error("Erro ao atualizar o próximo passo:", err);
      alert("Não foi possível atualizar o atendimento.");
    } finally {
      setLoadingId(null);
    }
  };

  return (
    <div className="container-consulta-processos">
      <div className="card">
        <h1>Clientes para Peticionar</h1>
        <div className="table-container">
          {atendimentos.length === 0 ? (
            <p>Nenhum cliente com status "peticionar".</p>
          ) : (
            <table className="table">
              <thead>
                <tr>
                  <th>Nome</th>
                  <th>CPF</th>
                  <th>Data do atendimento</th>
                  <th>Status</th>
                  <th>Dias</th>
                  <th>Ação</th>
                </tr>
              </thead>

              <tbody>
                {atendimentos.map((atendimento) => {
                  const id = atendimento.id || atendimento._id;
                  const cliente = atendimento.cliente || {};
                  const confirmandoEste = confirmandoId === id;
                  const carregandoEste = loadingId === id;
                  // Obtém o texto e a cor correspondente aos dias decorridos
                  const statusDias = obterStatusDias(atendimento.horarioCheckin);

                  return (
                    <tr key={id}>
                      <td>{formatarNomeUpper(cliente.nomeCliente)}</td>
                      <td style={{ textAlign: "center" }}>{aplicarMascaraCPF(cliente.cpf) || "-"}</td>
                      <td style={{ textAlign: "center" }}>
                        {atendimento.horarioCheckin
                          ? new Date(
                              atendimento.horarioCheckin
                            ).toLocaleDateString()
                          : "-"}
                      </td>
                      <td style={{ textAlign: "center" }}>{atendimento.proximoPasso}</td>
                      {/* RANKING DE DIAS COM COR DINÂMICA */}
                      <td
                        style={{
                          textAlign: "center",
                          fontWeight: "bold",
                          color: statusDias.cor,
                        }}
                      >
                        {statusDias.texto}
                      </td>
                      <td style={{ textAlign: "center" }}>
                        {confirmandoEste ? (
                          <div
                            style={{
                              display: "flex",
                              gap: "6px",
                              flexWrap: "wrap",
                            }}
                          >
                            <button
                              type="button"
                              onClick={() => handlePeticionar(atendimento)}
                              disabled={carregandoEste}
                            >
                              {carregandoEste ? "Salvando..." : "Confirmar"}
                            </button>

                            <button
                              type="button"
                              onClick={() => setConfirmandoId(null)}
                              disabled={carregandoEste}
                            >
                              Cancelar
                            </button>
                          </div>
                        ) : (
                          <button
                            type="button"
                            onClick={() => handlePeticionar(atendimento)}
                            disabled={carregandoEste}
                            style={{
                              backgroundColor: "#2563eb",
                              color: "#fff",
                              padding: "6px 10px",
                              border: "none",
                              borderRadius: "4px",
                              cursor: carregandoEste ? "not-allowed" : "pointer",
                            }}
                          >
                            Finalizar
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
        </div>
      </div>
    </div>
  );
};

export default Peticionar;